import { render } from "./AppContent.vue?vue&type=template&id=56b1425a&scoped=true"
const script = {}

import "./AppContent.vue?vue&type=style&index=0&id=56b1425a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b1425a"]])

export default __exports__